import { Component } from '@angular/core';

@Component({
    selector: 'error-forbidden',
    templateUrl: './forbidden.component.html',
    styles: [],
    standalone: false
})
export class ForbiddenComponent {
    constructor() { }
}